function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16 0c8.833.01 15.99 7.167 16 16 0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0zm5.867 13.333h-3.333a.334.334 0 01-.277-.518l2.619-3.928a1 1 0 00-.831-1.553H15.08c-.505 0-.967.284-1.193.736l-4.243 8.487a1 1 0 00.891 1.444h2.08a.332.332 0 01.316.439l-2.229 6.684a.666.666 0 001.105.683l10.765-10.765a1 1 0 00-.704-1.706z"
});

function SvgPowerBackup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _ref);
}

export default SvgPowerBackup;